import { Button, Dialog, Text } from '@/ui'

export const AccountDownloadDialog = ({
  open,
  close,
}: {
  open: boolean
  close: () => void
}) => {
  return (
    <Dialog open={open} onOpenChange={(val) => !val && close()}>
      <Dialog.Content className="max-w-md">
        <Dialog.Title>Account Download</Dialog.Title>
        <div className="py-4">
          <Text>
            Your account information is being prepared and should be available
            shortly. Once ready for download, you will receive an email
            notification with a link to download your information.
          </Text>
        </div>
        <Dialog.Footer>
          <Button onClick={close}>Close</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
